import { useTranslation } from "next-i18next";
import { GetStaticPropsContext } from "next";
import { useUTSLocaleContext } from "context/utsLocaleContext";
import { BlogLayout } from "layouts/pages/BlogLayout";
import { BlogPostShortProps } from "api/cms-website/cms-blog-posts.types";
import { getBlogPosts } from "api/cms-website/cms-blog-posts";

import { serverSideTranslations } from "utils/next/translations";
import { I18nToStrapiLocale, Theme } from "constants/enum";
import content from "content/blog";
import { checkIsNotFound } from "configs/unsupport-locale-routes";
import { UrlsConfig } from "configs/urlsConfig";
import { I18nLocale } from "constants/enum";
import { reportToSentry } from "utils/reportToSentry";

interface BlogPage {
    posts: BlogPostShortProps[];
}

export default function Blog({ posts }: BlogPage) {
    const { t } = useTranslation("global");
    const { locale } = useUTSLocaleContext();

    const pageContent = content(locale)(t, { locale });

    return <BlogLayout content={{ ...pageContent, posts }} />;
}

export async function getStaticProps({ locale }: GetStaticPropsContext) {
    if (checkIsNotFound(UrlsConfig.BLOG, locale as I18nLocale)) {
        return {
            notFound: true,
        };
    }

    const localeToLanguage = I18nToStrapiLocale[locale as I18nLocale];

    // Filter locales from Next 'default' locale
    if (!localeToLanguage)
        return {
            notFound: true,
        };

    try {
        const data = await getBlogPosts(localeToLanguage);

        if (!data?.length) {
            return { notFound: true };
        }

        return {
            props: {
                posts: data,
                ...(await serverSideTranslations(locale, [
                    "blog",
                    "navigationMenuRelaunch",
                ])),
                themeType: Theme.SYT,
            },
        };
    } catch (e) {
        const error = e as Error;
        reportToSentry({ error, extra: { ...error } });
        throw e;
    }
}
